var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBankCardFront56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12267_18184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18C6 14.6863 8.68629 12 12 12H44C47.3137 12 50 14.6863 50 18V38C50 41.3137 47.3137 44 44 44H12C8.68629 44 6 41.3137 6 38V18Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17,
    width: 44,
    height: 6,
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 32,
    width: 11,
    height: 6,
    rx: 2,
    fill: "#C9C9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12267_18184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 32,
    fill: "white",
    transform: "translate(6 12)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardFront56);
export default __webpack_public_path__ + "static/media/bank_card_front_56.29900d51.svg";
export { ForwardRef as ReactComponent };